import { createStore } from 'vuex'
import auth from '@/store/modules/auth'
import estabelecimento from '@/store/modules/estabelecimento'
import createPersistedState from "vuex-persistedstate"

export default createStore({
    modules: {
      auth,
      estabelecimento
    },
    plugins: [
      createPersistedState({
        key: 'app-consulta-estoque'
      })
    ]
  })
